import React from "react";

const Icon = ({ src, alt, width, height, className }) => {
  return <img alt={alt} src={src} width={width} height={height} className={className} />;
};

export default Icon;
